<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';
  import type { DataList } from '$provider/models/datalist/DataList';

  interface Props {
    item: DataList;
    onevent?: (payload: any) => void;
  }

  let { item, onevent }: Props = $props();
</script>

{#if item?.componentInfo?.component}
  <div class="value-comp">
    <item.componentInfo.component {...item.componentInfo.props} {onevent} />
  </div>
{:else if item?.value}
  <div data-cy={`${item.key}-v`} class="value">
    <div class="text">
      {(typeof item.value !== 'object' && item.value) || EmptyLabelDefault}
    </div>
  </div>
{/if}

<style>
  .value,
  .value-comp {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
